import React from 'react';
import './ExitIntentPopup.css';

const ExitIntentPopup = ({ show, onClose, onCheckout }) => {
  if (!show) return null;

  const handleCheckout = () => {
    onClose();
    if (onCheckout) onCheckout();
  };

  return (
    <div className="exit-popup-backdrop" onClick={onClose}>
      <div className="exit-popup" onClick={(e) => e.stopPropagation()}>
        <button className="exit-popup-close" onClick={onClose} aria-label="Close popup">
          ×
        </button>
        
        <div className="exit-popup-content">
          <div className="exit-popup-icon">⚠️</div>
          <h2>Wait! Don't Miss Your Visa Update</h2>
          <p className="exit-popup-text">
            Stop checking the visa decisions page every day. Get <strong>email alerts</strong> when your reference appears,
            optional browser alerts, and <strong>all 13 premium tools</strong> for <strong>₹349 one-time</strong>.
          </p>
          
          <div className="exit-popup-benefits">
            <div className="exit-benefit">
              <span className="benefit-check">✓</span>
              <span>Email alerts + optional browser alerts</span>
            </div>
            <div className="exit-benefit">
              <span className="benefit-check">✓</span>
              <span>No more manual refreshing</span>
            </div>
            <div className="exit-benefit">
              <span className="benefit-check">✓</span>
              <span>All 13 premium tools with one-time access</span>
            </div>
          </div>

          <div className="exit-popup-actions">
            <button className="btn-primary btn-shimmer" onClick={handleCheckout}>
              Upgrade for ₹349 – Alerts + 13 Tools →
            </button>
            <button className="btn-text" onClick={onClose}>
              No thanks, I'll keep checking manually
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
